module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.canFixProblems()
    },
    on: {
      "click": _vm.fixProblems
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-wrench"
  }), _vm._v(" Repair\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-defualt",
    attrs: {
      "disabled": !_vm.canDownloadValidations()
    },
    on: {
      "click": _vm.downloadValidations
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download"
  }), _vm._v(" Download (CSV)\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.isProcessingFix
    },
    on: {
      "click": _vm.refreshTable
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Refresh\n        ")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tableDiv"
    }
  }, [_c('strong', [_vm._v("Maximum of 50 records shown")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-condensed",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "mainTable"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7816f79a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7816f79a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-validation/model-validation.vue.html
// module id = 1117
// module chunks = 0